import React, { useCallback } from 'react';
import cogoToast from 'cogo-toast';

import { DEBOUNCE_DURATION } from 'data/asyncSelect';
import { useLazySearchLibraryQuery } from '@classCreation/services/libraryService';
import Select from 'components/Select';
import useDebouncedPromise from 'hooks/useDebouncedPromise';

const MIN_KEYWORD_LENGTH = 3;

export default function LibrarySelect(props) {
  const [fetchLibraries, { isFetching }] = useLazySearchLibraryQuery();

  const generateOptions = useCallback(
    (libraries) =>
      libraries.map((o) => ({
        value: o.id,
        label: o.title,
      })),
    []
  );

  const loadOptions = useDebouncedPromise(
    async (keyword, callback) => {
      if (keyword.length < MIN_KEYWORD_LENGTH) return callback([]);
      const response = await fetchLibraries({ keyword }, true);
      let options = [];
      if (response.data) {
        options = generateOptions(response.data.data);
      } else {
        cogoToast.error(
          response.error?.data?.message ||
            'Failed to load Libraries! Try again after sometime'
        );
      }
      callback(options);
    },
    DEBOUNCE_DURATION,
    [generateOptions]
  );

  const noOptionsMessage = useCallback(
    ({ inputValue }) => {
      if (inputValue.length < MIN_KEYWORD_LENGTH) {
        return `Type atleast ${MIN_KEYWORD_LENGTH} characters to search`;
      } else if (isFetching) {
        return `Searching...`;
      } else {
        return `No matching libraries found.`;
      }
    },
    [isFetching]
  );

  return (
    <Select
      {...props}
      type="async"
      placeholder="Select A Library"
      loadOptions={loadOptions}
      noOptionsMessage={noOptionsMessage}
    />
  );
}
